import { useEffect, useRef } from "react";

export function AutogrowTextarea({
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder,
  className,
  minRows = 2,
}: {
  value: string;
  onChange: (v: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  className?: string;
  minRows?: number;
}) {
  const ref = useRef<HTMLTextAreaElement | null>(null);
  // Resize to fit content. Set height to auto first so shrinking works, then
  // measure scrollHeight. min ≈ minRows × line-height (1.4em-ish for text-xs).
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight}px`;
  }, [value]);

  return (
    <textarea
      ref={ref}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      rows={minRows}
      className={className}
    />
  );
}
